/**
 * =============================================================================
 * IMPORTANT, READ THIS MESSAGE BEFORE EDITING THIS FILE.
 *
 * This file needs to be kept tightly in sync with its corresponding version in
 * the backend. If you are changing this file, please also make the
 * corresponding changes in
 * `functions/src/utils/courseUtils.ts` and submit both files simultaneously.
 *
 * Be careful because import paths may be different. Don't forget to double check
 * that you update the comments in `functions` as well.
 * =============================================================================
 */

import type {CourseId} from 'types/common';

/** COPY EVERYTHING STARTING HERE TO `functions` */

/**
 * Courses that we know are in Spanish, currently Uniandes and Pylatino.
 */
export const checkIsSpanishCourse = (courseId: CourseId | null): boolean => {
  let courseIdToCheck = courseId;

  // The courseId may be null if the React Router hasn't finished parsing the
  // URL yet. In that case, use the URL directly.
  if (!courseIdToCheck) {
    courseIdToCheck = window.location.pathname.split('/')[1] ?? '';

    // This condition only triggers if we're on the home page, trivially we're
    // not in a Spanish course.
    if (!courseIdToCheck) {
      return false;
    }
  }

  return (
    courseIdToCheck.includes('uniandes') ||
    checkIsPylatinoCourse(courseIdToCheck)
  );
};

/**
 * Courses from our partnership with Pylatino.
 */
export const checkIsPylatinoCourse = (courseId: CourseId): boolean => {
  let courseIdToCheck = courseId;

  // The courseId may be null if the React Router hasn't finished parsing the
  // URL yet. In that case, use the URL directly.
  if (!courseIdToCheck) {
    courseIdToCheck = window.location.pathname.split('/')[1] ?? '';

    // This condition only triggers if we're on the home page, trivially we're
    // not in a Pylatino course.
    if (!courseIdToCheck) {
      return false;
    }
  }
  return courseIdToCheck.includes('pylatino');
};

/**
 * "Public" courses are courses that are open to everyone and host applications
 * for limited enrollment courses.
 */
export const checkIsPublicCourse = (courseId: CourseId): boolean => {
  return (
    courseId.startsWith('public') || courseId.startsWith('pylatino-publico')
  );
};
